import {config} from '../stage.config';
import {useAccountContext} from '../lib/accountContext';

export const usePaymentUrl = (paymentId: string) => {
  const account = useAccountContext();
  const domain = account?.customDomain || config.hostedPaymentDomain;
  return `https://${domain}/payments/${paymentId}`;
};
